<template>
  <div>
    <div>
      <b-form ref="form" :style="{ height: trHeight }" class="repeater-form">
        <!-- Row Loop -->
        <b-form-row
          v-for="(item, index) in founders"
          :id="item.id"
          :key="item.id"
          ref="row"
        >
          <b-col lg="1" md="1">
            <b-form-group label="الرقم" label-for="number">
              <b-form-input id="number" :value="index + 1" plaintext />
            </b-form-group>
          </b-col>
          <!-- Item Name -->
          <b-col md="4">
            <b-form-group label="الاسم الثلاثي" label-for="item-name">
              <b-form-input
                v-model="founders[index].full_name"
                id="item-name"
                type="text"
              />
            </b-form-group>
          </b-col>

          <!-- Cost -->
          <b-col md="3">
            <b-form-group label="الرقم الوطني" label-for="idnum">
              <cleave
                v-model="founders[index].id_number"
                id="idnum"
                class="form-control"
                :options="{ numericOnly: true, blocks: [11] }"
              />
            </b-form-group>
            <!-- <b-form-group label="الرقم الوطني" label-for="cost">
              <b-form-input
                v-model="founders[index].id_number"
                id="cost"
                type="text"
              />
            </b-form-group> -->
          </b-col>

          <!-- Quantity -->
          <b-col md="4">
            <b-form-group label="عنوان السكن" label-for="address">
              <b-form-input
                v-model="founders[index].address"
                id="address"
                type="text"
              />
            </b-form-group>
          </b-col>
          <b-col lg="1" md="1"> </b-col>

          <!-- Profession -->
          <b-col lg="4" md="1">
            <b-form-group label="المؤهل العلمي" label-for="education">
              <b-form-input
                id="education"
                v-model="founders[index].qualifications"
                type="text"
              />
            </b-form-group>
          </b-col>
          <b-col lg="3" md="1">
            <b-form-group label="العمل" label-for="job">
              <b-form-input
                id="job"
                v-model="founders[index].jobs"
                type="text"
              />
            </b-form-group>
          </b-col>
          <b-col lg="3" md="1">
            <b-form-group label="رقم الهاتف" label-for="contact-num">
              <cleave
                v-model="founders[index].phone_number"
                id="phone-num"
                class="form-control"
                :options="{ numericOnly: true, blocks: [10] }"
              />
            </b-form-group>
          </b-col>

          <!-- Remove Button -->
          <b-col lg="1" md="1">
            <b-button
              v-ripple.400="'rgba(40, 199, 111, 0.15)'"
              variant="flat-danger"
              class="btn-icon rounded-circle mt-0 mt-md-2"
              v-b-tooltip.hover.v-danger.bottom
              title="إزالة العضو"
              @click="removeItem(index)"
            >
              <feather-icon icon="XIcon" />
            </b-button>
          </b-col>
          <b-col cols="12">
            <hr />
          </b-col>
        </b-form-row>
      </b-form>
    </div>
    <b-button
      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
      variant="info"
      @click="repeateAgain"
    >
      <feather-icon icon="PlusIcon" class="mr-25" />
      <span>إضافة عضو</span>
    </b-button>
  </div>
</template>

<script>
import {
  BForm,
  BFormGroup,
  BFormInput,
  BRow,
  BFormRow,
  BCol,
  BButton,
  VBTooltip,
} from "bootstrap-vue";
import { heightTransition } from "@core/mixins/ui/transition";
import Ripple from "vue-ripple-directive";
import Cleave from "vue-cleave-component";

export default {
  components: {
    BForm,
    BFormRow,
    BRow,
    BCol,
    BButton,
    BFormGroup,
    BFormInput,
    Cleave,
  },
  directives: {
    Ripple,
    "b-tooltip": VBTooltip,
  },
  props: {
    value: Array,
  },
  mixins: [heightTransition],
  data() {
    return {};
  },
  mounted() {
    this.initTrHeight();
  },
  created() {
    window.addEventListener("resize", this.initTrHeight);
  },
  destroyed() {
    window.removeEventListener("resize", this.initTrHeight);
  },
  computed: {
    founders: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  methods: {
    repeateAgain() {
      this.founders.push({
        id: this.$moment().valueOf(),
      });

      this.$nextTick(() => {
        this.trAddHeight(this.$refs.row[0].offsetHeight);
      });
    },
    removeItem(index) {
      this.founders.splice(index, 1);
      this.trTrimHeight(this.$refs.row[0].offsetHeight);
    },
    initTrHeight() {
      this.trSetHeight(null);
      this.$nextTick(() => {
        this.trSetHeight(this.$refs.form.scrollHeight);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.repeater-form {
  overflow: hidden;
  transition: 0.35s height;
}
</style>
